import { Component, Mixins, Watch } from 'vue-property-decorator';
import CanvasMixin from './CanvasMixin';
import ResizeObserver from 'resize-observer-polyfill';

@Component({})
export default class VerticalCanvas extends Mixins(CanvasMixin) {
  // needs update on ts to type
  resizeObserver = null;

  async mounted() {
    this.calculateScale();

    const container = this.$refs.canvasContainer;
    if (container) {
      this.resizeObserver = new ResizeObserver(entries => {
        for (const entry of entries) {
          this.calculateScale();
        }
      });
      this.resizeObserver.observe(container);
    }
  }

  beforeDestroy() {
    if (this.resizeObserver) {
      this.resizeObserver.disconnect();
      this.resizeObserver = null;
    }
  }

  @Watch('projectWidth')
  calculateScale() {
    const minimumPadding = 32; // 16 each side
    const container = this.$refs.canvasContainer;

    const availableWidth = container
      ? container.offsetWidth - minimumPadding
      : this.projectWidth;

    const availableHeight = container
      ? container.offsetHeight - minimumPadding
      : this.projectHeight;

    this.scaleFactor = Math.min(availableWidth / this.projectHeight, availableHeight / this.projectWidth);
  }

  get guideStyle() {
    const transform = `translate(
      ${-this.projectHeight / 2}px,
      ${-this.projectWidth / 2}px)
      scale(${this.scaleFactor})`;

    const data = {
      transform,
      width: `${this.projectHeight}px`,
      height: `${this.projectWidth}px`,
      top: '50%',
      left: '50%',
    };

    return data;
  }
}
